// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__1xWji","container":"modal_container__3_0wS"};